import "./Spin.scss";

const Spin = ({ modifier }) => {
  return (
    <>
      <div
        className={`animation ${
          modifier === "small"
            ? `animation--small`
            : modifier === "waiting"
            ? "animation--waiting"
            : ""
        }`}
      >
        <div className={`animation__spinner`} id={modifier}></div>
        {!modifier && (
          <p className="animation__text">
            Hold tight. This might take a moment. 🚀
          </p>
        )}
      </div>
    </>
  );
};

export default Spin;
